<template>
  <textarea
      ref="textarea"
      v-bind="$attrs"
      :value="value"
      class="input TEXTAREA"
      :style="{ height: `${initialHeight}px` }"
      @focus="resizeTextarea"
      @blur="resizeTextarea"
      @input="onTextareaInput"
  />
</template>

<script>
export default {
  name: 'textarea-input',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: String,
    initialHeight: Number,
  },
  watch: {
    value () {
      if (global.document.activeElement !== this.$refs.textarea) {
        this.resizeTextarea({ target: this.$refs.textarea });
      }
    },
  },
  mounted () {
    this.resizeTextarea({ target: this.$refs.textarea });
  },
  methods: {
    onTextareaInput ({ target }) {
      this.$emit('input', target.value.trim());

      this.resizeTextarea({ target });
    },
    resizeTextarea ({ target }) {
      const {
        flexGrow: flexGrowString,
        minHeight: minHeightPx,
        borderTopWidth: borderTopWidthPx,
        borderBottomWidth: borderBottomWidthPx,
      } = global.getComputedStyle(target);
      const minHeight = parseInt(minHeightPx, 10) || 48;
      const flexGrow = parseInt(flexGrowString, 10);

      if (flexGrow) {
        return;
      }

      // eslint-disable-next-line no-param-reassign
      target.style.height = `${minHeight}px`;

      global.requestAnimationFrame(() => {
        if (this.value || this.value !== this.$refs.textarea.value) {
          // eslint-disable-next-line no-param-reassign
          target.style.height = `${
            target.scrollHeight + parseInt(borderTopWidthPx, 10) + parseInt(borderBottomWidthPx, 10)
          }px`;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .TEXTAREA {
    @include text-large;
    will-change: height;
    transition: height $transition-half-duration;
    overflow: hidden;
    resize: none;

    &::placeholder {
      @include text-large;
    }

    &:focus {
      transition: none;
    }
  }
</style>
